<template>
  <div>
    <section class="grid-flex">
      <div id="howto" class="box">
        <div class="grid-flex stretch">
          <div class="box-content grid-flex row" style="width: 100%">
            <div class="w100" data-canny />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from "vuex";

import { generateSSOCanny } from "@/services/sso_canny";

export default {
  name: "sugestions",
  data() {
    return {};
  },
  mounted() {
    this.renderCanny();
    this.initCanny();
  },
  computed: {
    ...mapState({
      user: state => state.user,
      account: state => state.account
    })
  },
  methods: {
    renderCanny() {
      generateSSOCanny()
        .then(result => {
          if (window.Canny) {
            window.Canny("render", {
              boardToken: "ea076e16-e3ae-de64-e1ed-b871c4e149b6",
              ssoToken: result.sso_token
            });
          }
        })
        .catch((error) => {
          if (error && error.message === "request-canceled") {
            return;
          }
          this.$toast.error({
            title: "Erro",
            message: "Ocorreu um erro ao carregar os dados"
          });
        });
    },
    initCanny() {
      if (window.Canny) {
        let auxUser = this.user.is_superuser ? "administrador" : "normal";

        let auxCompanies = [];

        if (!this.user.is_staff) {
          auxCompanies.push({
            id: this.account.id,
            name: Math.floor(Math.random() * 1000000), // para preservar o nome da conta do cliente
            customFields: {
              plano: this.account.plan,
              codigo_assinatura: this.account.subscriber_code,
              plataforma: this.account.payment_platform,
              status_assinatura: this.account.status,
              tipo_usuario: auxUser,
              flag_atraso: this.account.flag_payment,
            }
          });
        }

        // anonimization name user
        let nameUser = Math.floor(Math.random() * 1000000)

        if (this.user.is_staff) {
          nameUser = this.user.name || this.user.email.split('@')[0]
        }

        // created: new Date(this.user.created_at).toISOString(),

        window.Canny("identify", {
          appID: "6334718c40155744b3e38112",
          user: {
            companies: auxCompanies,
            email: this.user.email,
            id: this.user.id,
            name: nameUser
          }
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
img {
  border-radius: 3px;
}
.list-videos {
  max-height: 550px;
  overflow: hidden;
  overflow-y: inherit;
  padding-left: 10px;
  padding-right: 10px;
  > ul {
    list-style-type: none;
    li {
      cursor: pointer;
      .active {
        background: #8c36fc1a;
        .title {
          border-bottom: 1px solid #999;
        }
      }
    }
  }

  .video-info {
    padding-left: 10px;
    width: 100%;

    .title {
      font-weight: 700;
      padding-bottom: 5px;
      border-bottom: 1px solid var(--border0);
    }

    .description {
      margin-top: 10px;
    }
  }
}

.w60 {
  width: 70%;
}

@media screen and (max-width: 1024px) {
  .row {
    flex-direction: column !important;
  }
  .w60 {
    width: 100%;
  }
  .w40 {
    width: 100%;
  }
  .list-videos {
    margin-top: 30px;
  }
}
</style>
